import Repository from '../axios'
import { defaultPagination } from "@/constants/config";

export default {
  getListOfSettings() {
    return Repository.get(`/landlord/settings`)
  },
  updateSettings(payload) {
    return Repository.post(`/landlord/settings`, payload)
  },
  uploadFile(formData) {
    return Repository.post(`/landlord/file-upload`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
}
